<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "home"
}
</script>

<style scoped>

</style>
